<!--
================================================
Une vue affichée en cas de subscription réusssie
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <app-layout-comp>
    <div slot="AppContent" id="SubscriptionSuccessView" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
      <div class="columns">
        <div class="column">

          <div class="compLoader" v-if="!componentIsReady">
            <spinner-loader-comp v-bind:loading-txt="$t('chargement')"></spinner-loader-comp>
          </div>
          <div v-else class="blocConfirm box px-6 py-6 has-text-left">

            <!-- CAS PAIEMENT D'UNE SUBSCRIPTION | OU RENSEIGNEMENT PAYMENT METHODE DURANT TRIAL -->
            <div v-if="subscription.status =='active' ||  subscription.status =='trialing' && subscription.defaultPaymentMethodId !=null">

              <img
                   class="m-auto mb-4 is-block trialIllustration"
                   src="../assets/img/illustrations/Agreement-amico.svg"
                   alt="illustration"
                   height="200px"
                   width="200px" />

              <div class="is-size-4 has-text-primary mb-4">
                <font-awesome-icon class="icon is-medium is-primary has-text-primary" :icon="['far', 'check-circle']"/>
                {{$t('AbonnementRéussi')}}

            </div>
              <h1 class="is-size-4 is-capitalized has-text-grey-dark mb-0">
                {{ $t('merciUntel', {firstname: user.firstname}) }} </h1>
              <p class="confirmMsg1 mb-2">{{ $t('VotreAbonnementVaEtreActivé') }}</p>
              <p class="confirmMsg2 has-text-grey mb-6"
                 v-html="$t('SiVousAvezLaMoindreQuestionNHésitezPasÀNousContacter')">
              </p>


              <div class="subReceipt block
                        is-radiusless has-background-white py-5 px-5 mb-5">
                <h4 class="is-size-7 has-text-grey">{{ $t('DétailDeVotreCommande') }}</h4>

                <div class="orderNum">
                  <span :alt="$t('réferenceDeLaCommande')"
                        class="tag has-text-grey-light my-2 ">{{ $t('réf:') }} {{ subscription.identifier }}</span>
                  <div class="date has-text-grey-light is-size-7">
                    {{ $moment(subscription.createdAt).tz(user.timezone).format('lll') }}
                  </div>

                </div>
                <div class="planName has-text-weight-bold mt-4 is-size-5 has-text-grey-dark">

                  {{$t('planCronocloud')}}
                  <span class="plan is-uppercase">{{ subscription.planName }}</span>
                </div>


                <div class="summary has-text-grey is-size-6 py-3 my-1">

                  <div class="is-size-7 trialMarker1" v-if="subscription.defaultPaymentMethodId !=null">
                    🎁 {{$t('EssaiGratuitJusquAuPuis',{date:$moment(subscription.trialEnd).format('l')})}}
                  </div>
                  <span v-html="$tc('xUtilisateurs',subscription.quantity)"></span>,
                  <span>{{
                      $t('x€ParUtilisateurParCycle', {
                        unitPrice: subscription.unitPrice,
                        currency: currencyToSign(subscription.currency),
                        cycle: i18nCycleName,
                      })
                    }}</span>

                  <div class="dateRange  is-size-7 has-text-grey-light">

                    <span v-if="subscription.defaultPaymentMethodId ==null">
                      {{
                        $t('valableDuDateAuDate', {
                          startDate: $moment(subscription.currentPeriodStart).tz(user.timezone).format('L'),
                          endDate: $moment(subscription.currentPeriodEnd).tz(user.timezone).format('L')
                        })
                      }}
                    </span>

                  </div>
                </div>


                <div class="total ">
                  {{ $t('Total:') }}


                  <span class="has-text-weight-bold ">
                    <span class="amount">{{ amountTotal }}</span>
                    <span class="sign"> {{ currencyToSign(subscription.currency) }}</span>
                       <span class="is-size-7 ml-2  trialMarker2" v-if="subscription.defaultPaymentMethodId !=null">
                        ({{ $t('débitéÀPartirDu', {date: $moment(subscription.trialEnd).format('l')}) }})
                      </span>
                  </span>
                </div>


              </div>
            </div>

            <!-- CAS ACTIVATION DU TRIAL -->
            <div v-else-if="subscription.status =='trialing' && subscription.defaultPaymentMethodId == null">
              <img
                  class="m-auto mb-4 is-block  trialIllustration"
                  src="../assets/img/illustrations/Gaming-amico.svg"
                  alt="illustration"
                  height="200px"
                  width="200px" />

              <div class="is-size-4 has-text-primary mb-4">
                <font-awesome-icon class="icon is-medium is-primary has-text-primary" :icon="['far', 'check-circle']"/>
                {{$t('EssaiGratuitDémarré')}}

              </div>
              <h1 class="is-size-4 is-capitalized has-text-grey-dark mb-0">
                {{ $t('merciUntel', {firstname: user.firstname}) }} </h1>
              <p class="confirmMsg1 mb-2"
                 v-html="$t('VousBénéficiezGratuitementDeLAboXJusqAuX',{plan:subscription.planName, date:$moment(subscription.trialEnd).tz(user.timezone).format('ll')
                  })">
              </p>
              <p class="confirmMsg2 has-text-grey mb-6"
                 v-html="$t('SiVousAvezLaMoindreQuestionNHésitezPasÀNousContacter')">
              </p>


            </div>


            <router-link id="back2Sub" class="button  is-size-6"
                         v-bind:to="{ name: 'workspace-subscription',params:{locale:locale,organization:organizationSlug, workspace:$auth.getActiveWorkspace()},query:{cycle:'month',pgr:planGroup4Locale}}">
              <font-awesome-icon class="icon is-size-7 has-text-grey-light" :icon="['fas', 'arrow-left']"/>
              <span>{{ $t('retourÀLAbonnement') }}</span>
            </router-link>


          </div>


        </div>
      </div>

    </div>
  </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
// @ is an alias to /src
import AppLayoutComp from '@/components/AppLayoutComp.vue'
// import Component from '@/components/Component.vue'
import VueMetaMixin from "../mixins/VueMetaMixin.js";
import SentryMixin from "../mixins/SentryMixin.js";
import InterceptorMixin from "../mixins/InterceptorMixin.js";
import GlobalErrorNotificationMixin from "../mixins/GlobalErrorNotificationMixin.js";
import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
import {mapState} from "vuex";
import {StripeCheckout} from '@vue-stripe/vue-stripe';
import CurrencyMixin from "@/mixins/CurrencyMixin";
import i18nMixin from "@/mixins/i18nMixin";
import TrackingMixin from "@/mixins/TrackingMixin";

export default {
  name: 'SubscriptionSuccessView',
  data: function () {
    return {


      locale: this.$route.params.locale,

      // pour les composants où l'user est identifié ///////////////////////
      organizationSlug: this.$route.params.organization,
      // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
      // componentIsReady : false, // indique quand le composant est prêt à être afficher
      activeWorkspace: this.$auth.getActiveWorkspace(), //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290
      //
      // =================================================================
      subscription: { // La subscription qui vient d'être crée
      },
      componentIsReady: false, // bool indique si le component a terminé de charger la subscription et peut être affiché
    }
  },
  computed: {

    // computed props for store :
    ...mapState({
      user: state => state.user,
      currentPeriod: state => state.ReportView.currentPeriod,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    //----------------------------------------------
    // other computed props :

    i18nCycleName: { // le nom ducycle de facturation traduit dans la llocale de l'utilisateur
      get: function () {
        if (this.subscription.billingCycle == 'month') {
          return this.$t('mois')
        } else if (this.subscription.billingCycle == 'year') {
          return this.$t('an')
        }
        ;
      },
    },


    amountTotal: {
    // le total de la subscription (unitPrice x user)
      get: function () {
        return this.subscription.unitPrice * this.subscription.quantity
      },
    }
    //----------------------------------------------


  },
  // watch: {
  //     // à chaque fois que la prop computed change, cette fonction s'exécutera
  //     user: function () {
  //     }
  // },
  components: {
    AppLayoutComp, SpinnerLoaderComp, StripeCheckout
    // Component,
  },
  mixins: [VueMetaMixin, SentryMixin, InterceptorMixin, GlobalErrorNotificationMixin, CurrencyMixin, i18nMixin, TrackingMixin],
  //==========================================================
  metaInfo() {
    return this.setMeta(this.$t("metaTitleSubscriptionSuccess"), this.$t("metaDescDefault"))
  },
  //==========================================================
  methods: {

    /**
    Track une action de souscription ecommerce dans Google analytics 4 avec vue-gtag
    @link https://matteo-gabriele.gitbook.io/vue-gtag/methods/purchase
    @link         //https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#purchase
    */
    trackSubscription(subscription) {

      // Tracking de l'ajout d'un moyen de paiement @link https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_payment_info
      if(this.subscription.defaultPaymentMethodId != null){
        this.ga4GlobalEventTrack('add_payment_info' , {subscriptionStatus: this.subscription.status})
        this.$mixpanel.track("Add payment info", {subscriptionStatus: this.subscription.status});
      }

      // Tracking de la conversion e-commerce (une seule fois)
      if (this.subscription.isTracked != true) {

        this.$gtag.purchase({
          currency: subscription.currency,
          transaction_id: subscription.identifier,
          value: this.amountTotal,
          // affiliation: "Google Store",
          coupon: subscription.coupon,
          // shipping: 3.33,
          // tax: 2.22,
          items: [
            {
              item_id: this.subscription.priceId,
              item_name: this.subscription.planName,
              // affiliation: "Google Store",
              coupon: subscription.coupon,
              currency: subscription.currency,
              // discount: 2.22,
              // index: 5,
              // item_brand: "Google",
              // item_category: "Apparel",
              // item_category2: "Adult",
              // item_category3: "Shirts",
              // item_category4: "Crew",
              // item_category5: "Short sleeve",
              // item_list_id: "related_products",
              // item_list_name: "Related Products",
              // item_variant: "green",
              // location_id: "L_12345",
              price: subscription.amount,
              quantity: subscription.quantity
            },
          ]
        })


        // tracking mixpanel @link https://mixpanel.com/blog/revenue-best-practices/
        this.$mixpanel.track("Premium subscription",
            {amount: this.amountTotal, plan: this.subscription.planName, priceId: this.subscription.priceId}
        );

        this.sendPatchMarkAsTracked()
      }

    },

    /*
    Effectue une requête pour récupérer la Subscription qui vient d'être réussie
    */
    loadSubscription() {
      let self = this;
      self.componentIsReady = false;
      self.$http.get(
          `organizations/${self.$auth.getOrganization()}/workspaces/${self.$auth.getActiveWorkspace()}/subscriptions/clientReferenceId/${self.clientReferenceId}`,
          {
            params: {},
            headers: {Authorization: self.$auth.header()},
            timeout: 20000 // surcharge timeout car la requête a tendance à prendre du temps (en dev ?) @todo à améliorer à terme ?

          }
      ).then(function (response) {
        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
        self.subscription = response.data
        self.trackSubscription(response.data)

        self.componentIsReady = true;

      })
          .catch(function (error) {
            let errorCode = '0059'
            let errorMsq = 'error fetching subscription'
            self.showGlobalErrorNotif(self,errorCode)
            self.$gtag.exception({'description': 'error '+errorCode + ' | '+errorMsq, 'fatal': false})
            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": errorMsq})
            self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsq} : ${error}`, 'error')

          })
    }

    /**
     * Envoie une requête patch pour indiquer que la subscription a été trackée dans analytics ecommerce
     * @return {Promise<{} | never>}
     */
    ,sendPatchMarkAsTracked(){
      this.isSubmiting = true;

      let self = this
      self.$http
          .patch(`/organizations/${self.organizationSlug}/workspaces/${self.$auth.getActiveWorkspace()}/subscriptions/markAsTracked/${self.subscription.identifier}`,
              {},
              {headers: {Authorization: self.$auth.header()}}
          )
          .then(function (response) {
            // self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
            this.logToSentry(self, 'Subscription mark "as tracked" (id : '+this.subscription.id, 'info');

            return {}
          })
          .catch(function (error) {
            // On catch ici sauf ce qui relève des intercepteurs Axios
            if(self.shouldBeIntercepted(error.response,self.$auth) === false){
              let errorCode = '0056'
              let errorMsq = 'error marking subscription "as tracked"'
              // self.showGlobalErrorNotif(self,errorCode)
              self.$gtag.exception({'description': 'error '+errorCode + ' | '+errorMsq, 'fatal': false})
              // self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": errorMsq})
              self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsq} : ${error}`, 'error')
            }
          })
          .then(function () {
            // self.isSubmiting = false;
          })
    },

  },

  created: function () {
  },

  mounted: function () {
    if (this.$route.query.client_reference_id != undefined) {

      this.clientReferenceId = this.$route.query.client_reference_id
      this.loadSubscription()

    }
  },
}
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
/*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/


#SubscriptionSuccessView {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////

  .subReceipt {
    border: dashed 1px $brandFourth;
    box-shadow: 0 3px 7px #ddd;

    .summary {
      border: solid 1px #eee;
      border-width: 1px 0;
    }

    .total {
      color: $brandFourth;
      .amount {
      }
      .trialMarker2{color: #ccc !important;}

    }
  }


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .box {
      background-color: $bulmaBoxBgDark !important;
      color: $darkTxt;

      h1 {
        color: $darkContrastTxt !important;
      }

      .button {
        color: $darkTxt;
        background-color: transparent;
      }
    }


    .subReceipt {
      background-color: $darkBg3 !important;
      border-color: $brandFourth;
      box-shadow: none;

      .tag {
        background-color: $darkBg4;
        color: $darkLightBlue !important;
      }

      .planName {
        color: $darkContrastTxt !important;
      }

      .summary {
        border-color: $darkFieldBorder;
      }
      .total {
        color: $darkTxt;
        .amount {
        }
        .trialMarker2{color: #888 !important;}
      }
    }

  }

}
</style>
